export default function editProject(
  {patch}: any,
  {
    projectId,
    name,
    evaluationDate,
    customer,
    usersInvolved,
  }: {projectId: number; name: string; evaluationDate: string; customer: string; usersInvolved: string[]},
): Promise<{}> {
  return patch(
    `/projects/${projectId}/edit`,
    {name, evaluationDate, customer, usersInvolved},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/projects/editProject.tsx